<div class="database-page-sider">
  <div class="top-bar">
    <div class="sider-label">
      <span>Filter Menu</span>
    </div>
    <div id="save-view-content">
      <va-button
        btnType="outline"
        size="small"
        [isOnlyIcon]="true"
        (click)="toggleSider()"
        btnType="solid"
      >
        <va-icon size="small" name="sliders-horizontal" ></va-icon>
      </va-button>
    </div>
  </div>

  <app-database-page-facet> </app-database-page-facet>
</div>
